const HeadingTitle = ({ onClick, title_name, line_class, heading_class }) => {
    return (
        <div className="w-full flex flex-wrap sm:flex-nowrap items-center">
            <h2 onClick={onClick} className={`text-[#D0D9DA] font-primary leading-[36px] md:leading-[50px] 2xl:leading-[80px] sm:whitespace-nowrap uppercase pb-3 sm:pb-0 ${heading_class}`}>{title_name}</h2>
            <span className={`fill-animation block w-full h-1 rounded-md from-[#D0D9DA] to-[rgba(207, 217, 218, 0.1)] z-10 ${line_class}`}></span>
        </div>
    )
}

export default HeadingTitle;